/** Art aus dem Namen eines Max-Kolonie-Abzeichens lesen (neues und altes Namensformat) */
export function maxColonySpecies(name: string): string {
  const n = name || '';
  return n.match(/^Großkolonie:\s*(.+)$/)?.[1]
    ?? n.match(/ausgewachsene (.+?) Kolonie/)?.[1]
    ?? n;
}
